import React, {useContext, useState, useEffect} from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound404 from '../pages/notFound404'
import MainLayout from "../pages/MainLayout";
import ListPage from "../pages/ListPage";
import Dashboard from "../pages/Dashboard";
import Messenger from "../pages/Messenger";
import Connected from "../pages/Connected";
import AdminPage from "../pages/admin";
import { GlobalState } from '../store/GlobalState';
import LoginUser from './LoginUser';
import LoginAdmin from './LoginAdmin';
import Chinhsach from '../pages/chinhsach';
import Dieukhoan from '../pages/dieukhoan';
import XoaDuLieu from '../pages/XoaDuLieu.js';

function App() {
  const state = useContext(GlobalState)
  const [islogged] = state.isAuthenticated
  const [checked, setChecked] = useState(false)

  useEffect(()=>{
    const checkLogin = ()=>{
      if(sessionStorage.getItem('islogged')){
        setChecked(true)
      }
    }
    checkLogin()
  })

  return (
    <Routes>
        <Route element={checked?(<MainLayout />):(<LoginUser/>)}>
          <Route path="/" element={checked?(<Dashboard />):(<LoginUser/>)}/>
          <Route path="/:id" element={checked?(<Dashboard />):(<LoginUser/>)}/>
          <Route path="/list-page" element={checked?(<ListPage />):(<LoginUser/>)}/>
          <Route path="/messenger" element={checked?(<Messenger />):(<LoginUser/>)}/>
          <Route path="/connected" element={checked?(<Connected />):(<LoginUser/>)}/>
          <Route path="*" element={<NotFound404 />} />
        </Route>
        <Route>
          <Route path="/admin" element={checked?(<AdminPage />):(<LoginAdmin/>)}/>
          <Route path="/chinh-sach-bao-mat" element={<Chinhsach />}/>
          <Route path="/dieu-khoan-dich-vu" element={<Dieukhoan />}/>
          <Route path="/huong-dan-xoa-du-lieu" element={<XoaDuLieu />}/>
          {/* <Route path="/admin" element={(<AdminPage />)}/> */}
        </Route>

        {/* <Route element={(<MainLayout />)}>
          <Route path="/" element={(<Dashboard />)}/>
          <Route path="/list-page" element={(<ListPage />)}/>
          <Route path="/user" element={(<User />)}/>
          <Route path="*" element={<NotFound404 />} />
        </Route>
        <Route>
          <Route path="/admin" element={(<AdminPage />)}/>
        </Route> */}
    </Routes>
  );
}

export default App;